export default {
	"AdditionalPageTypes": false,
	"Admin": true,
	"Advertising": true,
	"AggregatedContentFeed": false,
	"AllowCustomFields": false,
	"AppConfig": false,
	"AppEcommerceManager": false,
	"AppScorePredictor": false,
	"AppSocialManager": false,
	"AppTicketingManager": false,
	"BreakingNews": false,
	"BuildManager": true,
	"Calendar": false,
	"CustomCommentary": true,
	"CustomLineups": true,
	"CustomTables": false,
	"CustomTags": false,
	"Dashboard": true,
	"Fixtures": true,
	"Forms": false,
	"HomepageManager": true,
	"HomepageNewsPromo": false,
	"HomepagePlayerHighlight": true,
	"Lab": false,
	"MatchdayTakeover": false,
	"Media": true,
	"News": true,
	"OptaIntegration": true,
	"Organisations": false,
	"OverlayPromos": false,
	"Pages": true,
	"PlatformOptions": false,
	"PlayerVoting": false,
	"PreventEntitlementEmails": false,
	"Profile": true,
	"RelatedContentTagging": true,
	"RewardsManager": false,
	"RewardPoints": false,
	"Rover": false,
	"Settings": false,
	"SiteConfig": true,
	"Sponsors": false,
	"Squads": true,
	"SsoUsers": false,
	"StreamAMGIntegration": false,
	"Streamline": false,
	"StreamlineAdverts": false,
	"StreamlinePromoCodes": false,
	"TeamCrestManager": false,
	"Videos": false,
	"Voice": false,
	"WebStats": true
}
